import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';

import { CondicaoPagamentoFilter } from '../filter';
import { CondicaoPagamentoCrudHttpService } from '../services';
import { condicaoPagamentoAtiva, isCondicaoPagamentoSituacaoInativa } from '../condicao-pagamento-situacao';
import { CondicaoPagamento } from '../condicao-pagamento';

@Component({
    selector: 'sgt-condicao-pagamento-select',
    templateUrl: './condicao-pagamento-select.component.html',
    styleUrls: ['./condicao-pagamento-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CondicaoPagamentoSelectComponent), multi: true },
    ]
})
export class CondicaoPagamentoSelectComponent implements OnInit {
    /** ID da condição de pagamento */
    @Input() ngModel: number;
    /** Ao alterar a condição de pagamento */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Condição de Pagamento */
    @Input() condicaoPagamento: CondicaoPagamento;
    @Output() condicaoPagamentoChange = new EventEmitter<CondicaoPagamento>();

    /** Condições de pagamentos */
    condicoesPagamentos: CondicaoPagamento[] = [];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se deve pesquisar as condições de pagamentos ao iniciar o component */
    @Input() searchOnInit = true;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUMA CONDIÇÃO DE PAGAMENTO'
    /** Se deve filtrar somente as condições de pagamentos ativas */
    @Input() somenteAtivas = false;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private condicaoPagamentoCrudHttpService: CondicaoPagamentoCrudHttpService) { }

    ngOnInit() {
        if (this.searchOnInit) {
            this.search();
        }
    }


    /** Pesquisa as condições de pagamentos */
    search(): Promise<CondicaoPagamento[]> {
        return new Promise<CondicaoPagamento[]>((resolve, reject) => {
            this.condicoesPagamentos = [];


            const filter = new CondicaoPagamentoFilter();
            // Somente ativas
            if (this.somenteAtivas) {
                filter.situacao = condicaoPagamentoAtiva.id;
            }


            this.condicaoPagamentoCrudHttpService.searchWithFilter(filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    condicoesPagamentos => {
                        this.condicoesPagamentos = condicoesPagamentos;

                        if (this.condicaoPagamento) {
                            const indexCondicaoPagamento = this.condicoesPagamentos?.findIndex(condicaoPagamentoFilter => condicaoPagamentoFilter.id === this.condicaoPagamento.id);
                            if (indexCondicaoPagamento < 0) {
                                this.condicoesPagamentos.unshift(this.condicaoPagamento);
                            }
                        }

                        resolve(this.condicoesPagamentos);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as condições de pagamentos', error);
                        reject(error);
                    }
                );
        });
    }

    /** Verifica se a condição de pagamento está inativa */
    isSituacaoInativa(situacao: number): boolean {
        return isCondicaoPagamentoSituacaoInativa(situacao);
    }

    /** Ao alterar a condição de pagamento */
    onChange(idCondicaoPagamento: number) {
        this.ngModel = idCondicaoPagamento;
        this.propagateChange(this.ngModel);

        this.condicaoPagamento = this.condicoesPagamentos?.find(condicaoPagamentoFilter => condicaoPagamentoFilter.id === idCondicaoPagamento);
        this.condicaoPagamentoChange.emit(this.condicaoPagamento);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
